import React, { useEffect, useState, useRef } from 'react'
import ReactModal from 'react-modal'
import '../../styles/modals/FeedBackModal.css'
import { ReactComponent as CloseModalIcon } from '../../assets/svg/CloseModalIcon.svg'
import { ReactComponent as DropdownTransparent } from '../../assets/svg/DropdownTransparent.svg'
import { ReactComponent as SearchBlue } from '../../assets/svg/SearchBlue.svg'
import { emotions_color, emotions_heads, reasonsJson } from '../../constants/Constants'
import { useTranslation } from 'react-i18next'
import { convertDateToFormatddMMyyy, format_day_only, formatAlertDate, notify } from '../../utils/util'
import { makeAssignment, getTeachersForAssignment, getSuperiorTeachers } from '../../server/server'
import TextareaAutosize from 'react-textarea-autosize'
import { Toaster } from 'react-hot-toast'
import Loading from '../Loading'
import ExpandButton from '../common/ExpandButton'
import { SingleEmotionDetails } from '../analytics/student/AlertsWidget'
import BaseModal from './BaseModal/BaseModal'

function WellBeingAsignModal({ modalIsOpen, closeModal, student, note, assignMessage = '', multipleEmotions = false, isAlert = false }) {
    const { t, locale } = useTranslation()
    const [showDropdown, setShowDropdown] = useState(false)
    const [teachers, setTeachers] = useState([])
    const [loadedTeachers, setLoadedTeachers] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [message, setMessage] = useState(assignMessage)
    const [selectedTeacher, setSelectedTeacher] = useState({})
    const [processing, setProcessing] = useState(false)
    const [superiorTeachers, setSuperiorTeachers] = useState({})

    useEffect(() => {
        if (modalIsOpen) {
            loadTeachers()
            loadSuperiorTeachers()
        }
    }, [modalIsOpen, student])

    useEffect(() => {
        if (searchTerm.length > 0) {
            setTeachers(loadedTeachers.filter((teacher) => `${teacher?.first_name} ${teacher?.last_name}`.toLowerCase().includes(searchTerm?.toLowerCase())))
        } else setTeachers(loadedTeachers)
    }, [searchTerm])

    const loadSuperiorTeachers = async () => {
        const resp = await getSuperiorTeachers(student)
        if (resp.status === 200) {
            if (resp?.data?.headOfClass || resp?.data?.headOfYear) setSuperiorTeachers(resp.data)
        }
    }

    const loadTeachers = async () => {
        const resp = await getTeachersForAssignment({ student_id: student?.id })
        if (resp.status === 200) {
            setLoadedTeachers(resp?.data)
            setTeachers(resp?.data)
        }
    }

    const assignAction = async () => {
        if (selectedTeacher.first_name === undefined) {
            notify(t('Select teacher'), 'warning')
            return
        }
        if (!message || message.trim() === '') {
            notify(t('youMustFillData'), 'warning')
            return
        }
        let data = {
            message: message,
            teacher: selectedTeacher,
        }
        if (note?.feedback_id && !multipleEmotions) data['feedback_id'] = note.feedback_id
        else if (isAlert) {
            if (multipleEmotions) data['alert_id'] = note.id || note?.alert_id
            else data['feedback_id'] = note?.id
        } else data['student_id'] = student?.id
        setProcessing(true)
        const resp = await makeAssignment(data)
        if (resp.status === 200) {
            notify(t('actionHasBeenAssignedToTeacher'))
            closeModal(true)
        } else {
            notify(t('assignActionFailed'), 'error')
        }
        setProcessing(false)
    }

    React.useEffect(() => {
        if (modalIsOpen && assignMessage) {
            setMessage(assignMessage)
        }
    }, [modalIsOpen])

    const handleTeacherSelect = (teacher) => {
        setSelectedTeacher(teacher)
        setShowDropdown(false)
        setSearchTerm('')
    }

    const renderTeacherItem = (teacher, role) => (
        <div
            onClick={() => handleTeacherSelect(teacher)}
            className="w-full min-h-[50px] bg-white rounded-[5px] flex flex-row items-center justify-between mb-2 px-5 cursor-pointer border border-highlightColor hover:bg-highlightColor transition"
        >
            <p className="text-[16px] leading-5 font-bold text-darkenPurple">{`${teacher?.first_name} ${teacher?.last_name}`}</p>
            <p className="text-[14px] leading-5 font-medium text-deepPurple">{role || teacher?.role_coverage?.target_text}</p>
        </div>
    )

    const cleanUpFunction = () => {
        setMessage('')
        setSelectedTeacher({})
        setShowDropdown(false)
    }

    return (
        <BaseModal isOpen={modalIsOpen} onClose={closeModal} onAfterClose={cleanUpFunction}>
            <div className=" w-full bg-whiteContrast rounded-[10px]  ">
                {!multipleEmotions && <SingleEmotionHeader student={student} note={note} />}
                {multipleEmotions && <MultipleEmotionsHeader student={student} note={note} />}
                {/* background: #fafaff; */}
                <div className="rounded-[10px] py-5 ">
                    <div className="max-h-[calc(100vh-200px)] rounded-[10px] overflow-auto overscroll-contain py-1 px-[30px]  ">
                        {!!note?.message && (
                            <div className="feedback-modal-messege-body">
                                <p>{t('comment')} </p>
                                <span>{note.message}</span>
                            </div>
                        )}

                        <div className="flex flex-col mt-3  ">
                            <p className="text-[#5E639B] font-semibold text-[18px] leading-[22px]">{t('Assign to')}:</p>
                            <AssignTeacherDropdown
                                teachers={teachers}
                                superiorTeachers={superiorTeachers}
                                selectedTeacher={selectedTeacher}
                                searchTerm={searchTerm}
                                setSearchTerm={setSearchTerm}
                                showDropdown={showDropdown}
                                setShowDropdown={setShowDropdown}
                                onSelect={handleTeacherSelect}
                            />

                            {!showDropdown && <AssignmentMessageSection message={message} setMessage={setMessage} processing={processing} onSubmit={assignAction} />}
                        </div>
                    </div>
                </div>
            </div>
        </BaseModal>
    )
}

const AssignmentMessageSection = ({ message, setMessage, processing, onSubmit }) => {
    const { t } = useTranslation()

    return (
        <div className="feedback-assigned-multiline mt-[16px]">
            <div className="feedback-textarea">
                <TextareaAutosize
                    placeholder={t('typeAnAction')}
                    id="action-message-textarea"
                    minRows={5}
                    value={message}
                    style={{ resize: 'none' }}
                    onChange={(e) => setMessage(e.target.value)}
                />
            </div>

            <button className="textarea-button" id="text-area-button" onClick={onSubmit} disabled={processing}>
                {processing ? <Loading /> : <p>{t('submit')}</p>}
            </button>
        </div>
    )
}

const AssignTeacherDropdown = ({ teachers, superiorTeachers, selectedTeacher, searchTerm, setSearchTerm, showDropdown, setShowDropdown, onSelect }) => {
    const { t } = useTranslation()

    return (
        <div className="flex flex-col mb-[10px] w-full mt-4">
            <div
                className="feedback-info-select-button"
                onClick={(e) => {
                    e.preventDefault()

                    if (searchTerm) {
                        setSearchTerm('')
                    }

                    setShowDropdown((prev) => !prev)
                }}
                style={{
                    justifyContent: 'center',
                    zIndex: 3,
                    backgroundColor: showDropdown ? '#5E639B' : '#ecebf8',
                }}
            >
                <p
                    style={{
                        color: showDropdown ? 'white' : '#5E639B',
                    }}
                >
                    {selectedTeacher?.first_name ? `${selectedTeacher.first_name} ${selectedTeacher.last_name}` : t('selectTeacher')}
                </p>

                <div
                    style={{
                        transform: showDropdown ? 'scaleY(-1)' : 'none',
                        marginLeft: 10,
                    }}
                >
                    <DropdownTransparent
                        style={{
                            color: showDropdown ? 'white' : '#5E639B',
                        }}
                    />
                </div>
            </div>

            {showDropdown && (
                <div className="-mt-[55px] flex flex-col items-end w-full bg-lightBG rounded-[28px] cursor-pointer z-[2]">
                    <div className="rounded-[28px] w-full pb-6 mt-14">
                        <div className="flex flex-col px-3 w-full">
                            <div className="feedback-management-search-container">
                                <input
                                    id="feedback-management-search-input"
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    autoComplete="off"
                                    placeholder={t('search')}
                                />

                                <SearchBlue />
                            </div>

                            {superiorTeachers?.headOfClass && <TeacherItem teacher={superiorTeachers.headOfClass} role={t('classroomTeacher')} onSelect={onSelect} />}

                            {superiorTeachers?.headOfYear && <TeacherItem teacher={superiorTeachers.headOfYear} role={t('headOfYear')} onSelect={onSelect} />}

                            {(superiorTeachers?.headOfYear || superiorTeachers?.headOfClass) && (
                                <p className="text-[14px] leading-5 font-medium text-deepPurple my-[15px] text-center">{t('otherTeachers')}</p>
                            )}

                            {teachers?.map((teacher) => (
                                <div key={teacher.id} onClick={() => onSelect(teacher)} className="feedback-teacher-item">
                                    <p style={{ textAlign: 'left' }}>
                                        {teacher?.first_name} {teacher?.last_name}
                                    </p>

                                    <p>{teacher?.role_coverage?.target_text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

const TeacherItem = ({ teacher, role, onSelect }) => {
    return (
        <div
            onClick={() => onSelect(teacher)}
            className="w-full min-h-[50px] bg-white rounded-[5px] flex flex-row items-center justify-between mb-2 px-5 cursor-pointer border border-highlightColor hover:bg-highlightColor transition"
        >
            <p className="text-[16px] leading-5 font-bold text-darkenPurple">
                {teacher?.first_name} {teacher?.last_name}
            </p>

            <p className="text-[14px] leading-5 font-medium text-deepPurple">{role || teacher?.role_coverage?.target_text}</p>
        </div>
    )
}

export const SingleEmotionHeader = ({ student, note }) => {
    const { t, locale } = useTranslation()
    return (
        <div className=" rounded-[10px] px-[30px] pt-[35px] pb-[27px]" style={{ background: `${emotions_color[note?.emotion]}85` }}>
            <div className="flex flex-row items-center">
                <div>
                    <img src={!!note?.emotion ? emotions_heads[note?.emotion] : emotions_heads['default']} width={70} height={70} alt="emotion" />
                </div>
                <div className="feedback-header-title">
                    <p>
                        {student?.first_name} {student?.last_name}
                    </p>
                    <span>{note?.created_date ? format_day_only(note?.created_date) : format_day_only(new Date())}</span>
                </div>
                <div style={{ flex: 1 }}></div>
            </div>
            {!!note?.reasons?.length && (
                <div className="mt-[11px] -mb-[6px] flex flex-row items-center">
                    <p className="text-[#5E639B] font-bold text-[18px] mr-[10px]">{t('Reasons')}:</p>
                    <div className="flex flex-row gap-[15px] items-center flex-1">
                        {note?.reasons?.map((reason, index) => (
                            <div key={index} className="flex flex-row">
                                {reasonsJson[reason.toLowerCase()]}
                                {<span className="text-[#5E639B] uppercase font-semibold text-[16px] ml-[5px]">{t(reason?.toLowerCase())}</span>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export const MultipleEmotionsHeader = ({ student, note }) => {
    const { t, i18n } = useTranslation()
    const [open, setOpen] = useState(false)

    const expandableRef = useRef(null)

    const getExpandedHeight = () => {
        return expandableRef.current?.scrollHeight || 0
    }
    return (
        <div className=" rounded-[10px] px-[30px] pt-[35px] pb-[27px]" style={{ background: `#ECEBF8` }}>
            <div className="flex flex-col relative gap-[8px]">
                <div className="flex flex-row gap-[4px] text-[#5E639B]">
                    {note.feedbacks.map((e) => (
                        <img src={emotions_heads[e?.emotion]} width={32} height={32} alt="emotion" />
                    ))}
                </div>
                <div className="">
                    <p className="text-[18px] text-deepPurple text-medium">
                        <b>
                            {student?.first_name} {student?.last_name}{' '}
                        </b>
                        {t('has logged multiple uncomfortable emotions')}
                    </p>
                    <span className="text-[12px] text-[#413F5E] font-medium">{formatAlertDate(note.feedbacks, i18n.language)}</span>
                </div>
                <div className="absolute top-0 right-0 border-[#F8F8FB] border rounded-full bg-[#F8F8FB]">
                    <ExpandButton open={open} onClick={() => setOpen((prev) => !prev)} />
                </div>
            </div>

            <div
                className={`flex flex-col gap-[10px] mt-[20px] max-h-0 transition-all ${open ? `overflow-visible` : 'overflow-hidden'}`}
                ref={expandableRef}
                style={{ maxHeight: open ? getExpandedHeight() : '0', opacity: open ? 1 : 0 }}
            >
                {note?.feedbacks?.slice(0, 4).map((emotion) => (
                    <SingleEmotionDetails emotion={emotion} key={emotion.id} onlyIcon />
                ))}
            </div>

            {!!note?.reasons?.length && (
                <div className="mt-[11px] -mb-[6px] flex flex-row items-center">
                    <p className="text-[#5E639B] font-bold text-[18px] mr-[10px]">{t('Reasons')}:</p>
                    <div className="flex flex-row gap-[15px] items-center flex-1">
                        {note?.reasons?.map((reason, index) => (
                            <div key={index}>
                                {reasonsJson[reason.toLowerCase()]}
                                {<span className="text-[#5E639B] uppercase font-semibold text-[16px] ml-[5px]">{t(reason?.toLowerCase())}</span>}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default WellBeingAsignModal
